import React from 'react';

import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Flex,
  Button,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { FiAlertTriangle } from 'react-icons/fi';

import { useUserContext } from '@/context/user-context';
import { USER_STORAGE } from '@/services/config';

export const ModalForInvalidAccount = ({
  isModalValidateAccount,
  setIsModalValidateAccount,
}) => {
  const { user: currentUser } = useUserContext();
  const user = JSON.stringify(currentUser).replace('"active":0', '"active":2');

  return (
    <Modal
      isOpen={isModalValidateAccount}
      size="lg"
      onClose={() => setIsModalValidateAccount(false)}
      closeOnOverlayClick={false}
    >
      <ModalOverlay>
        <ModalContent bgColor="gray.50">
          <ModalHeader>
            <Flex>
              <FiAlertTriangle style={{ width: '40px', height: '30px' }} />
              Validez votre compte
            </Flex>
          </ModalHeader>
          <ModalBody>
            Merci de consulter votre messagerie pour valider votre compte
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="brandSecondary"
              mr={3}
              onClick={() => {
                setIsModalValidateAccount(false);
                localStorage.setItem(USER_STORAGE, user);
              }}
            >
              Accueil
            </Button>
          </ModalFooter>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
};

ModalForInvalidAccount.propTypes = {
  isModalValidateAccount: PropTypes.bool,
  setIsModalValidateAccount: PropTypes.func,
};

ModalForInvalidAccount.defaultProps = {
  isModalValidateAccount: false,
  setIsModalValidateAccount: () => {},
};
